import { render, staticRenderFns } from "./AdvisoryPackageFlow.vue?vue&type=template&id=40222d2e&scoped=true"
import script from "./AdvisoryPackageFlow.vue?vue&type=script&lang=js"
export * from "./AdvisoryPackageFlow.vue?vue&type=script&lang=js"
import style0 from "./AdvisoryPackageFlow.vue?vue&type=style&index=0&id=40222d2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40222d2e",
  null
  
)

export default component.exports